import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box
} from '@mui/material';

import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import { useNavigate, Link } from 'react-router-dom';

import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from '../../common/CommonRestricted';
import DataGridToolbar from '../../common/DataGridToolbar';
import DataGridTable from '../../common/DataGridTable';

import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useRegions, regionTypes } from '../../../hooks/api/useRegions';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from "../../../hooks/useTranslations";

const ListCountries = ({
    routeType
}) => {
    const { t } = useTranslations({ ns: ["common", "@region", "@location"] })

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useRegions({ regionType: regionTypes.country });

    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.region.id, scopeTypes.region.country.id)

    const gridRef = useRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            props.regionType = regionTypes.country

            const result = await list(props)

            return {
                data: result?.data?.countries,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }
    }

    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: 'country_name',
                header: t('country'),
                renderValue: ({ value, cellProps }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`settings/country/update/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: 'sort_name', header: t('sortName')
            },
            {
                name: 'phone_code', header: t('phoneCode')
            },
            {
                name: 'status',
                header: t('status'),
                renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, ["Enabled", "Disabled"], ["primary", "default"], "")
            }
        ])
    }

    const RenderToolbar = () => {

        return <></>

        // const getToolbarMainMenus = () => {

        //     let props = [];

        //     if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
        //         props.push({
        //             // displayText: "New Delivery Orders",
        //             displayIconName: icons.plus,
        //             onClick: () => {

        //                 navigate(getRoute("documents/deliveryOrder/new"));

        //             }
        //         })
        //     }

        //     return props
        // }

        // const getActionOnClick = () => {

        //     let handleFunction = null

        //     if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
        //         handleFunction = handleDelete
        //     }

        //     return handleFunction
        // }

        // return (
        //     <DataGridToolbar
        //         selectedRowCount={
        //             selectedIds.length
        //         }
        //         mainMenus={
        //             getToolbarMainMenus()
        //         }
        //         actionOnClickRemove={
        //             getActionOnClick()
        //         }
        //         actionMenus={[]}
        //     />
        // )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    checkboxColumn: false,
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        // console.log('items selected : ', items)
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )

    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.regions })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("countries")}
                breadcrumbs={[
                    {
                        displayText: t("countries"),
                        props: {
                            // underline: "hover",
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}

export default ListCountries;
